import { projectContext } from '@/layouts/MainLayout'
import { getProjectMembers } from '@/services/member/member'
import { getTask } from '@/services/task/task'
import { Task } from '@/services/task/task.model'
import { useInterval, useRequest, useUpdate } from 'ahooks'
import { Breadcrumb } from 'antd'
import classnames from 'classnames'
import { memo, useContext, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import TaskName from '../components/TaskField/TaskName'
import TaskComments from './Comments'
import TaskDescription from './Description'
import DetailForm from './DetailForm'
import styles from './index.module.less'
import Predecessors from './Predecessors'
import SubtaskList from './SubtaskList'

const ProjectTaskDetail = memo(function () {
  const { id } = useParams()
  const taskId = Number(id)
  const { projectId } = useContext(projectContext)
  const { data: members = [] } = useRequest(() => getProjectMembers(projectId))
  const [task, setTask] = useState<Task.Info>()
  useRequest(() => getTask(taskId), { onSuccess: (data) => setTask(data) })
  const updateTask = (data) => setTask((origin) => ({ ...origin, ...data }))

  // 一分钟更新一次组件
  const update = useUpdate()
  useInterval(() => update(), 1000 * 60)

  if (!task) {
    return null
  }

  return (
    <div className={styles.container}>
      <Breadcrumb className={styles.breadcrumb}>
        <Breadcrumb.Item>
          <Link to={'../'}>Task List</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>Task Details</Breadcrumb.Item>
      </Breadcrumb>

      <div className={classnames(styles.content, 'container-xl')}>
        <div className={styles.detail}>
          <div className={styles.title}>
            {task.parentId && (
              <div className={styles.parentTask}>
                Parent task:
                <Link to={`../${task.parentId}`} className={'link'}>
                  {task.parentName}
                </Link>
              </div>
            )}
            <div>
              <span className={styles.name}>
                <TaskName task={task} onSuccess={updateTask} />
              </span>
              <span className={styles.num}>#{task.num}</span>
            </div>
          </div>

          <TaskDescription task={task} onSuccess={updateTask} />

          <SubtaskList task={task} members={members} />

          <Predecessors task={task} members={members} />

          <TaskComments task={task} members={members} updateTask={updateTask} />
        </div>

        <DetailForm task={task} members={members} updateTask={updateTask} />
      </div>
    </div>
  )
})

export default ProjectTaskDetail
